<script setup>
import MerchCard from '@components/global/merch/card.vue'
import { useStoreStore } from '@stores/store'
import Button from '@components/global/button.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'


const route = useRoute()
const slug = computed(() => route.params.slug)

const store = useStoreStore()
const collection = computed(() => store.collection(route.params.slug) ?? null)
</script>

<template>
	<img src="https://hennep.s3.amazonaws.com/above/images/articles/article-bg.svg" alt="" class="absolute -right-[30%] top-[0] hidden h-full w-full md:block" />

	<img src="https://hennep.s3.amazonaws.com/above/images/" alt="" />
	<section class="container flex flex-col gap-8 md:gap-16">
		<div class="flex flex-col gap-8 uppercase">
			<div class="flex items-center justify-start gap-4 break-words font-body text-body-xs font-medium uppercase text-text-base">
				<span>products</span>
				<i class="fas fa-chevron-right text-[10px] text-text-muted/50"></i>
				<span>{{ slug }}</span>
			</div>
			<h1 class="break-words font-heading text-h2 font-medium uppercase text-sf-purple-base md:text-h1">{{ slug }}</h1>
			<img src="https://hennep.s3.amazonaws.com/above/images/home/products/planet.png" alt="" class="absolute bottom-0 right-[10%] hidden w-[170px] rotate-45 xl:block" />
			<img src="https://hennep.s3.amazonaws.com/above/images/home/products/planet2.png" alt="" class="absolute right-0 top-10 hidden w-10 rotate-45 xl:block" />
		</div>
	</section>

	<section class="container flex flex-col gap-20">
		<div class="flex flex-col gap-8 xl:flex-row">
			<!-- Filters -->
			<div class="flex w-full max-w-[260px] flex-col gap-4">
				<Button v-for="category in categories" :key="category" class="group items-center gap-1 border-b border-dashed border-border-base pb-2 last:border-b-0" @click="selectedCategory = category">
					<div class="flex items-center gap-3">
						<div class="relative size-5">
							<div class="animation h-full w-full rotate-45 border border-solid border-transparent group-hover:border-text-base" :class="selectedCategory === category && '!border-text-base'" />
							<div class="absolute-center animation flex group-hover:rotate-45" :class="selectedCategory === category ? 'h-1.5 w-1.5 rotate-45 bg-text-base' : 'rotate-270 h-1 w-1 bg-text-muted/50 group-hover:bg-text-base'" />
						</div>

						<p class="animation font-body text-body-md text-text-muted/50 group-hover:text-text-base" :class="selectedCategory === category && '!text-text-base'">
							{{ category }}
						</p>
					</div>
				</Button>
			</div>

			<div class="flex w-full flex-col gap-10">
				<!-- Products grid -->
				<div class="grid w-full grid-cols-1 gap-5 self-stretch md:grid-cols-2 xl:grid-cols-3">
					<MerchCard v-for="product in collection.products" :key="product.id" :item="product" />
				</div>
				<!-- <Button class="btn-outline self-center">load more</Button> -->
			</div>
		</div>
	</section>
</template>
